@if (visible || isInvalid()) {
	<div class="form-control-error-list">
		@if (visibleErrors.length > 0) {
			<ul>
				@for (error of visibleErrors; track error.key) {
					<li>
						@switch (error.key) {
							@case ('max') {
								{{ error.translationKey | translate: { value: error.value?.max | number: '0.2-2' } }}
							}
							@case ('min') {
								{{ error.translationKey | translate: { value: error.value?.min | number: '0.2-2' } }}
							}
							@default {
								{{ error.translationKey | translate }}
							}
						}
					</li>
				}
			</ul>
		}
	</div>
}
